import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultFilmContextDisplayText = {
    failedToLoadDataTitle: 'Sorry, something went wrong.',
    failedToLoadDataMessage: 'Refresh your browser or try loading the film again.',
    failedToLoadDataRetryButtonLabel: 'Try again'
};
export const filmContextDisplayTextValidatorSchema = {
    failedToLoadDataTitle: nonEmptyStringValidator,
    failedToLoadDataMessage: nonEmptyStringValidator,
    failedToLoadDataRetryButtonLabel: nonEmptyStringValidator
};
export const filmContextDisplayTextValidator = Validator.object(filmContextDisplayTextValidatorSchema);
